import { createClient } from '@sophya/eyekia';

// const innerClient = createClient('http://localhost:8080');
const innerClient = createClient(process.env.REACT_APP_API_ENDPOINT);

export const client = () => {
  return innerClient;
};
